import * as React from "react"
import { RouterProvider } from "react-router-dom"

import { appRouter } from "@/app/router"

const analyticsModuleId = "@vercel/analytics/react"

type AnalyticsComponent = React.ComponentType
type AnalyticsModule = {
  Analytics?: AnalyticsComponent
}

function OptionalAnalytics() {
  const [Analytics, setAnalytics] = React.useState<AnalyticsComponent | null>(null)

  React.useEffect(() => {
    let cancelled = false

    void import(/* @vite-ignore */ analyticsModuleId)
      .then((module) => {
        if (cancelled) return

        const analyticsModule = module as AnalyticsModule
        setAnalytics(() => analyticsModule.Analytics ?? null)
      })
      .catch(() => {
        if (cancelled) return
        setAnalytics(null)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return Analytics ? <Analytics /> : null
}

export default function App() {
  return (
    <>
      <RouterProvider router={appRouter} />
      <OptionalAnalytics />
    </>
  )
}
